<template>
  <div
    v-if="onlineRetailers"
    :class="['online-retailers-list-fi', variant ? `online-retailers-list-fi--${variant}` : null]"
  >
    <div class="online-retailers-list-fi__facets">
      <facets-menu-fi
        :facets="retailerFacets"
        :centered="!isProductRetailers"
        :columns-max="isProductRetailers ? 3 : 6"
        @change="facetChanged"
        @clear-all-facets="clearAllFacets"
      />
    </div>

    <div class="online-retailers-list-fi__retailers">
      <grid-container-fi>
        <div
          :class="{
            'fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12 lg:fi-col-start-3 lg:fi-col-end-11':
              !variant,
            'fi-col-start-1 fi-col-end-13': isProductRetailers,
          }"
        >
          <div class="online-retailers-list-fi__retailers__counter">
            {{
              $dict.get('retail-Connect-Cart.Checkout.Labels.Results-Counter', [
                onlineRetailers.length,
              ])
            }}
          </div>
          <retail-connect-online-retailer-fi
            v-for="retailer in onlineRetailers"
            :key="retailer.Id"
            :retailer="retailer"
            :variant="variant"
            :cart-id="cartId"
          />
        </div>

        <div
          v-if="
            fields.onlineRetailersNotice1?.value ||
            fields.onlineRetailersNotice2?.value ||
            fields.onlineRetailersNotice3?.value
          "
          class="online-retailers-list-fi__notices"
        >
          <div
            v-if="fields.onlineRetailersNotice1?.value"
            class="online-retailers-list-fi__notice"
          >
            <icon-fi
              icon="info"
              class="online-retailers-list-fi__notice__icon"
            />
            <span class="online-retailers-list-fi__notice__text">{{
              fields.onlineRetailersNotice1.value
            }}</span>
          </div>
          <div
            v-if="fields.onlineRetailersNotice2?.value"
            class="online-retailers-list-fi__notice"
          >
            <icon-fi
              icon="info"
              class="online-retailers-list-fi__notice__icon"
            />
            <span class="online-retailers-list-fi__notice__text">{{
              fields.onlineRetailersNotice2.value
            }}</span>
          </div>
          <div
            v-if="fields.onlineRetailersNotice3?.value"
            class="online-retailers-list-fi__notice"
          >
            <icon-fi
              icon="info"
              class="online-retailers-list-fi__notice__icon"
            />
            <span class="online-retailers-list-fi__notice__text">{{
              fields.onlineRetailersNotice3.value
            }}</span>
          </div>
        </div>
      </grid-container-fi>
    </div>
  </div>
</template>

<script>
import { IconFi } from 'atoms';
import FacetsMenuFi from 'components/facets/facets-menu-fi/FacetsMenuFi';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import RetailConnectOnlineRetailerFi from 'components/retail-connect/retail-connect-online-retailer/RetailConnectOnlineRetailerFi';

export default {
  name: 'OnlineRetailersListFi',
  components: {
    IconFi,
    GridContainerFi,
    RetailConnectOnlineRetailerFi,
    FacetsMenuFi,
  },
  inject: ['fields'],
  props: {
    retailers: {
      type: Array,
      default: null,
    },
    retailerFacets: {
      type: Array,
      default: null,
    },
    variant: {
      type: String,
      default: null,
    },
    cartId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      filteredRetailers: null,
      filtredFacets: null,
      activeFilters: [],
    };
  },
  computed: {
    onlineRetailers() {
      if (this.filteredRetailers) {
        return this.filteredRetailers;
      }

      return this.retailers;
    },
    facets() {
      if (this.filtredFacets) {
        return this.filtredFacets;
      }

      return this.retailerFacets;
    },
    isProductRetailers() {
      return this.variant === 'product-retailers';
    },
  },
  methods: {
    updateFacets() {
      const facets = [...this.facets];

      facets.forEach((facet) => {
        facet.elements.forEach((element) => {
          let counter = 0;

          this.filteredRetailers.forEach((retailer) => {
            if (retailer[element.facetType]?.[element.facetName]) {
              counter += 1;
            }
          });

          element.selected = this.activeFilters.indexOf(element) >= 0;

          element.count = counter;

          element.disabled = counter === 0;
        });
      });

      this.filtredFacets = facets;
    },
    facetChanged(filter) {
      const newfilteredRetailers = [];

      if (filter.value) {
        this.activeFilters.push(filter.element);
      } else {
        const index = this.activeFilters.indexOf(filter.element);
        this.activeFilters.splice(index, 1);
      }

      this.retailers.forEach((retailer) => {
        let inActiveRetailer = false;

        this.activeFilters.forEach((activeFilters) => {
          if (!retailer[activeFilters.facetType][activeFilters.facetName]) {
            inActiveRetailer = true;
          }
        });

        if (!inActiveRetailer) {
          newfilteredRetailers.push(retailer);
        }
      });

      this.filteredRetailers = newfilteredRetailers;
      this.updateFacets();
    },
    clearAllFacets() {
      this.filteredRetailers = [...this.retailers];
      this.activeFilters = [];
      this.updateFacets();
    },
  },
};
</script>

<style scoped lang="scss">
@import './online-retailers-list-fi';
</style>
